import axios from '@/plugins/Axios'

function Requests () {
  async function fetchBuyerAddresses () {
    try {
      const { data } = await axios.get('/address')
      return data.addresses
    } catch (error) {
      console.log(error)
    }
  }

  async function addBuyerAddress (address) {
    try {
      const { data } = await axios.post('/address', address)
      return data
    } catch (error) {
      return error.response.data
    }
  }

  async function updateBuyerAddress (address) {
    try {
      const { data } = await axios.put(`/address/${address.id_token}`, address)
      return data
    } catch (error) {
      return error.response.data
    }
  }

  async function deleteBuyerAddress (id) {
    try {
      const { data } = await axios.delete(`/address/${id}`)
      return data
    } catch (error) {
      return error.response.data
    }
  }

  return {
    fetchBuyerAddresses,
    addBuyerAddress,
    updateBuyerAddress,
    deleteBuyerAddress
  }
}

export default Requests()
